import { cn } from "../lib/utils";

interface LockupProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const SIZE_PX = { sm: 28, md: 32, lg: 40 } as const;

export function Lockup({ size = "md", className }: LockupProps) {
  const px = SIZE_PX[size];
  return (
    <img
      src="/agentic-league.svg"
      alt="Agentic League"
      width={px}
      height={px}
      className={cn("block flex-shrink-0", className)}
      style={{ width: px, height: px }}
    />
  );
}
